export enum FileUploadErrors {
  Error_001 = 'fileUpload.fileUploadWrongName',
  Error_002 = 'fileUpload.fileUploadFailed',
  Error_003 = 'fileUpload.fileUploadWrongSize',
  Error_004 = 'fileUpload.fileUploadWrongNameLength',
  Error_005 = 'fileUpload.fileUploadGenericError',
  Error_006 = 'fileUpload.fileUploadMustBeProvided',
  Error_007 = 'fileUpload.fileUploadDisallowedExtensions',
  Error_008 = 'fileUpload.fileUploadUnitTesting',
}

export function getFileUploadErrorTranslations(
  scope: string,
): Record<string, string> {
  return Object.fromEntries(
    Object.entries(FileUploadErrors).map(([errorCode, translationKey]) => {
      const mappedTranslationKey = [
        'Error_006',
        'Error_007',
        'Error_008',
      ].includes(errorCode)
        ? FileUploadErrors.Error_005
        : translationKey;

      return [errorCode, `${scope}.${mappedTranslationKey}`];
    }),
  );
}
